import { request } from "@/api/request"

/** 教程列表（不分页） */
export function fetchBookCourses(payload = {}) {
  return request.post("/mgm-crm-api/book/course-query", payload).then(r => r.data)
}

/** 教材列表（不分页） */
export function fetchBooks(payload = {}) {
  return request.post("/mgm-crm-api/book/query", payload).then(r => r.data)
}

/** 申请教材库存 */
export function applyBookStock(payload) {
  return request.post("/mgm-crm-api/book-apply/apply", payload).then(r => r.data)
}

/** 教材申请记录列表（已提交） */
export function fetchBookApplyList(payload = {}) {
  return request.post("/mgm-crm-api/book-apply/query", payload).then(r => r.data)
}

/** 教材审批列表（待处理、已处理） */
export function fetchBookApplyApprovalList(payload = {}) {
  return request.post("/mgm-crm-api/book-apply/query-approval-list", payload).then(r => r.data)
}

/** 教材审批-同意 */
export function approveBookApplyPass(payload) {
  return request.post("/mgm-crm-api/book-apply/approve-pass", payload).then(r => r.data)
}

/** 教材审批-驳回 */
export function approveBookApplyReject(payload) {
  return request.post("/mgm-crm-api/book-apply/approve-reject", payload).then(r => r.data)
}

/** 教材申请-取消申请 */
export function approveBookApplyCancel(payload) {
  return request.post("/mgm-crm-api/book-apply/approve-cancel", payload).then(r => r.data)
}

/** 教材审批-转交中心 */
export function toCenterBookApply(payload) {
  return request.post("/mgm-crm-api/book-apply/to-center", payload).then(r => r.data)
}

/** 教材审批-发放教材 */
export function issuedBookApply(payload) {
  return request.post("/mgm-crm-api/book-apply/issued-books", payload).then(r => r.data)
}

/** 教材申请-学员课程查询（新增申请时选学员） */
export function fetchBookApplyStudentCourse(payload = {}) {
  return request.post("/mgm-crm-api/book-apply/query-student-course", payload).then(r => r.data)
}
